import { type AppEnvironment, getEnvironment } from './getEnvironment';

const ENV_TITLE_PREFIXES: Record<AppEnvironment, string> = {
  LOCAL: '[dev] ',
  STAGING: '[stg] ',
  REVIEW: '[review] ',
  PREVIEW: '[preview] ',
  PRODUCTION: '',
};

const ENV_PREFIX_PATTERN = /^\[(?:dev|stg|review|preview)\]\s+/;

const CURRENT_ENV_PREFIX = ENV_TITLE_PREFIXES[getEnvironment()];

export function getEnvTitlePrefix(): string {
  return CURRENT_ENV_PREFIX;
}

/**
 * Idempotently prefixes `document.title` with the current env tag.
 * Strips any pre-existing env prefix before applying, so repeated calls are safe.
 */
export function applyEnvPrefixToDocumentTitle(): void {
  const stripped = document.title.replace(ENV_PREFIX_PATTERN, '');
  document.title = `${CURRENT_ENV_PREFIX}${stripped}`;
}
